import * as React from 'react'
import { useState } from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import CommonContext, { CommonContextType, CurrentUserType, WarehouseType } from '../CommonContext'
import FormFields from './FormFields'
import TemplateManager from './TemplateManager'
import useResourcesRecordFormController from '../../hooks/useResourcesRecordFormController'
import { PartnerShape, MachineShape } from '../../api/api_data_types'

const queryClient = buildQueryClient()

type ResourcesRecordsAppProps = {
  record: any
  availableWorktypes: [string, number][]
  availableWorkcards: [string, number][]
  availableWarehouses: WarehouseType[]
  availableMachines: MachineShape[]
  availablePartners: PartnerShape[]
  allPartners: PartnerShape[]
  allowPartners: boolean
  hideMachines: boolean
  hideItems: boolean
  hidePackagings: boolean
  hideShipments: boolean
  hidePurchases: boolean
  currentUser: CurrentUserType
  dynamicsnavPrefix?: string
}

export default function ResourcesRecordsApp(props: ResourcesRecordsAppProps) {
  const { formData, setFormData } = useResourcesRecordFormController(props.record)

  const [dictionaries, setDictionaries] = useState<CommonContextType>({
    availableWorktypes: props.availableWorktypes,
    availableWorkcards: props.availableWorkcards,
    availableWarehouses: props.availableWarehouses,
    availablePartners: props.availablePartners,
    allPartners: props.allPartners,
    currentUser: props.currentUser,
    dynamicsnavPrefix: props.dynamicsnavPrefix,
    updateCurrentUser: user => {
      setDictionaries({ ...dictionaries, currentUser: user })
    },
  })

  return (
    <CommonContext.Provider value={dictionaries}>
      <QueryClientProvider client={queryClient}>
        <TemplateManager
          formData={formData}
          setFormData={setFormData}
          currentUser={dictionaries.currentUser}
          updateCurrentUser={dictionaries.updateCurrentUser}
        />
        <FormFields {...props} formData={formData} setFormData={setFormData} />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
